<template>
  <Box>
    <div class="box-content">
      <div class="title">{{ $t('promotion.referFriends.totalEarnings') }}</div>
      <div class="total_amount">${{ totalAmount | formatNumber }}</div>
      <el-button class="el-button blue_button" :disabled="totalAmount === 0 || isDisabledRedeemButton" @click="clickRedeem">
        <span>{{ $t('promotion.referFriends.redeemButtonRedeem') }}</span>
      </el-button>
    </div>
  </Box>
</template>

<script>
import Box from '@/components/box/Box.vue';

export default {
  name: 'Redeem',
  props: {
    totalAmount: Number,
    campaignId: Number,
    isDisabledRedeemButton: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  components: {
    Box
  },
  methods: {
    clickRedeem() {
      this.$emit('clickRedeem');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/overview/redeem.scss';
</style>
